import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import stl from "./Header.module.css";
import { useTranslation } from "@i18n";
import loadable from "@loadable/component";
import useIsMobile from "@hooks/useIsMobile";
import useIsBrowser from "@hooks/useIsBrowser";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { URL_SELL_TRADE_LANDING } from "@/pages/module-sell-trade/SellTradeContext";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import useHelpers from "@hooks/useHelpers";
import { useLocation } from "react-router-dom";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { dispatchSideMenuToggle as toggleMenu } from "@/_LayoutsRelated/layoutHooks/useSideMenuController";
var fallback = /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
var UnbxdTextSearch = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-components-UnbxdTextSearch-UnbxdTextSearch";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-SearchComponent-UnbxdComponents-UnbxdAsideFilters-components-UnbxdTextSearch-UnbxdTextSearch" */"../../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("../../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch");
    }
    return eval('require.resolve')("../../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/components/UnbxdTextSearch/UnbxdTextSearch");
  }
}, fallback);
var DownloadAppBanner = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "DownloadAppBanner-DownloadAppBanner";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "DownloadAppBanner-DownloadAppBanner" */"./DownloadAppBanner/DownloadAppBanner");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./DownloadAppBanner/DownloadAppBanner");
    }
    return eval('require.resolve')("./DownloadAppBanner/DownloadAppBanner");
  }
}, fallback);
var Header = function Header(props) {
  var _useTranslation = useTranslation(["web_header", "web_common"]),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var isBrowser = useIsBrowser();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var location = useLocation();
  var isNew = location.pathname.includes("new-cars");
  var isHome = ["/", "/home/new-cars", "/en", "/en/home/new-cars"].includes(location.pathname);
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.custommobileHeaderFragmentOnly ? props.custommobileHeader : props.custommobileHeader && /*#__PURE__*/React.createElement("div", {
    className: props.custommobileHeader ? ["m-show", stl.custommobileHeader].join(" ") : undefined
  }, props.custommobileHeader), /*#__PURE__*/React.createElement("header", {
    className: [stl.siteHeader, props.revampedSearch ? stl.revampedHeader : "", props.className ? props.className : "", props.hideHeaderOnmobile ? "m-hide" : undefined, props.straightHeader ? stl.straightHeader : ""].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    id: "desktopHeader",
    className: ["container", stl.innerHdr, props.mobileHasTitle ? "mobHasTitleContainer" : ""].join(" ")
  }, !props.tracking ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: [props.showSearchBar ? "SearchHEader" : undefined, stl.backFlex].join(" ")
  }, props.mobileHasBack && isBrowser && history.state != null && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      document.querySelector(".backtolisting") != null ? window.location.href = document.querySelector(".backtolisting").querySelector("a").getAttribute("href") : history.back();
    },
    className: ["m-show", stl.mobileBackBlueArr].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mobileBackBlueArr.svg",
    alt: "back"
  })), /*#__PURE__*/React.createElement("a", {
    className: [props.logoNotClickable ? stl.disableLink : undefined, props.mobileNoLogo ? "m-hide" : ""].join(" "),
    href: createUrl("/")
  }, /*#__PURE__*/React.createElement("img", {
    width: 83,
    height: 38,
    className: [stl.logoSizeRev, "hasEvents"].join(" "),
    src: CDN_LINK + "/assets/images/logoN.svg",
    alt: "syarah logo icon"
  }))), /*#__PURE__*/React.createElement("p", {
    className: ["m-show", stl.mobHasTitle].join(" ")
  }, props.mobileHasTitle)) : /*#__PURE__*/React.createElement("a", {
    onClick: function onClick() {
      return history.back();
    },
    className: stl.trackingLink
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/trackinh-header.svg",
    alt: ""
  }), t("العودة لتتبع السيارة", {
    ns: "web_header"
  })), props.showSearchBar && /*#__PURE__*/React.createElement(UnbxdTextSearch, {
    setPage: props.setUnbxdPage
  }), !props.hideSideMenue && /*#__PURE__*/React.createElement("ul", null, !props.headHideLinks && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: [stl.revampLink, isHome && !isNew ? stl.activeLink : ""].join(" ")
  }, /*#__PURE__*/React.createElement("a", {
    id: "QA_Auto_UsedTab",
    className: "QA_Auto_UsedTab",
    href: createUrl("/")
  }, t("مستعملة مضمونة", {
    ns: "web_header"
  }))), /*#__PURE__*/React.createElement("li", {
    className: [stl.revampLink, isHome && isNew ? stl.activeLink : ""].join(" ")
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/home/new-cars"),
    id: "QA_Auto_NewTab"
  }, t("جديدة", {
    ns: "web_header"
  })))), !props.hideOrangeHeadBtn && /*#__PURE__*/React.createElement("li", {
    className: [stl.sellCarNewBtn, "sellNewBtn", stl.newBtnOrng].join(" ")
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl(URL_SELL_TRADE_LANDING),
    className: stl.sellCarBtn,
    onClick: function onClick() {
      trackEvents("sell_car_started", {
        referral_location: "header",
        platform: getPlatformInfo()
      });
    }
  }, isLoggedIn ? t("اعرض سيارتك للبيع", {
    ns: "web_aside_menu"
  }) : t("بدل/بيعنا سيارتك", {
    ns: "web_aside_menu"
  }))), /*#__PURE__*/React.createElement("li", {
    className: stl.lastLiRev
  }, !props.hideBurgerMenu && /*#__PURE__*/React.createElement(React.Fragment, null, props.burgrMenuisCncl && isMobile ? /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return window.history.back();
    },
    className: "cnclHDR"
  }, t("إلغاء", {
    ns: "web_common"
  })) : !props.tracking ? /*#__PURE__*/React.createElement("span", {
    onClick: toggleMenu,
    className: "sideMenuToggle m-hide cursor-pointer"
  }, !isMobile && /*#__PURE__*/React.createElement(ProgressiveImage, {
    "data-id": "burgerMenu",
    fetchpriority: "low",
    className: [stl.MenuIcnSizeRev, "hasEvents"].join(" "),
    src: CDN_LINK + "/assets/images/menuToggle.svg",
    width: 24,
    height: 16,
    alt: "T"
  })) : null)))), isMobile && !props.hideAppBanner && /*#__PURE__*/React.createElement(DownloadAppBanner, null), !props.headHideLinks && !props.headHideLinksMobile && /*#__PURE__*/React.createElement("ul", {
    className: [stl.mobileTabs, "m-show"].join(" ")
  }, /*#__PURE__*/React.createElement("li", {
    className: [stl.revampLink, isHome && !isNew ? stl.activeLink : ""].join(" ")
  }, /*#__PURE__*/React.createElement("a", {
    id: "QA_Auto_UsedTab_mobile",
    className: "QA_Auto_UsedTab_mobile",
    href: createUrl("/")
  }, t("مستعملة مضمونة", {
    ns: "web_header"
  }))), /*#__PURE__*/React.createElement("li", {
    className: [stl.revampLink, isHome && isNew ? stl.activeLink : ""].join(" ")
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/home/new-cars"),
    id: "QA_Auto_NewTab_mobile",
    className: "QA_Auto_NewTab_mobile"
  }, t("جديدة", {
    ns: "web_header"
  }))))));
};
export default Header;